import Loadable from 'react-loadable';

// code viewer util
export default Loadable({
  loader: () => import('./codeViewerImpl'),
  loading: () => 'Loading Code Viewer...'
});
